var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _User_props;
export class User {
    constructor(props) {
        _User_props.set(this, void 0);
        __classPrivateFieldSet(this, _User_props, props, "f");
    }
    get Email() { return __classPrivateFieldGet(this, _User_props, "f").schema.Email; }
    get Enabled() { return __classPrivateFieldGet(this, _User_props, "f").schema.Enabled; }
    get LoginName() { return __classPrivateFieldGet(this, _User_props, "f").schema.LoginName; }
    get Name() { return __classPrivateFieldGet(this, _User_props, "f").schema.Name; }
    get Office() { return __classPrivateFieldGet(this, _User_props, "f").schema.Office; }
    get OfficeId() { return __classPrivateFieldGet(this, _User_props, "f").schema.OfficeId; }
    get Position() { return __classPrivateFieldGet(this, _User_props, "f").schema.Position; }
    get ProfileId() { return __classPrivateFieldGet(this, _User_props, "f").schema.ProfileId; }
    get SectionBaseId() { return __classPrivateFieldGet(this, _User_props, "f").schema.SectionBaseId; }
    get SectionId() { return __classPrivateFieldGet(this, _User_props, "f").schema.SectionId; }
    get UserId() { return __classPrivateFieldGet(this, _User_props, "f").schema.UserId; }
    get EnterpriseApplication() { return __classPrivateFieldGet(this, _User_props, "f").schema.EnterpriseApplication; }
    get ExternalUser() { return __classPrivateFieldGet(this, _User_props, "f").schema.ExternalUser; }
    get sections() {
        return __classPrivateFieldGet(this, _User_props, "f").sdk.Sections.where(x => x.BaseId == this.SectionBaseId);
    }
    get currentSection() {
        const currentTrdVersion = __classPrivateFieldGet(this, _User_props, "f").sdk.currentTrdVersion;
        const sections = currentTrdVersion === null || currentTrdVersion === void 0 ? void 0 : currentTrdVersion.Sections;
        const result = (sections === null || sections === void 0 ? void 0 : sections.firstOrDefault(x => x.BaseId == this.SectionBaseId)) || null;
        return result;
    }
    GetComboBoxOption() {
        return {
            key: this.UserId,
            text: this.Name
        };
    }
    IsMemberOf(...roleId) {
        return true;
    }
}
_User_props = new WeakMap();
